module.exports = __webpack_public_path__ + "img/45.people_counter.fc25da7f.svg";